import WorkOtherList from './WorkOtherList';

export default WorkOtherList;
